import * as React from 'react';
import { useReference_unstable } from './useReference';
import { renderReference_unstable } from './renderReference';
import { useReferenceStyles_unstable } from './useReferenceStyles.styles';
import type { ReferenceProps } from './Reference.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

export const Reference: ForwardRefComponent<ReferenceProps> = React.forwardRef((props, ref) => {
  const state = useReference_unstable(props, ref);

  useReferenceStyles_unstable(state);
  return renderReference_unstable(state);
});

Reference.displayName = 'Reference';
